import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { ParameterModel } from 'src/app/core/interfaces/parameter.model';
import { ParametersService } from 'src/app/core/services/parameters.service';

import Swal from 'sweetalert2';
import { MoviesService } from 'src/app/core/services/movies.service';
import { Account } from 'src/app/core/interfaces/user.model';
import { AccountService } from 'src/app/core/services/account.service';


@Component({
  selector: 'app-press-movies',
  templateUrl: './press-movies.component.html',
  styleUrls: ['./press-movies.component.css']
})
export class PressMoviesComponent implements OnInit {

  movies: MovieModel[] = [];
  loading: boolean = false;
  authorised = false;
  PARAMS: ParameterModel;
  account: Account;


  constructor(
    private moviesService: MoviesService,
    private router: Router,
    private accountService: AccountService,
  ) { }

  async ngOnInit() {

    this.loading = true;

    console.log("entra prensa");

    this.accountService.getAccount().then(
      (res: Account) => {
        if (res) {
          this.account = res;
          if (!this.account.hasPressAccess) {
            this.denyEntry();
          }
          else {
            this.authorised = true;
          }
        }
      },
      (error) => {
        this.denyEntry();
      },
    );


    this.moviesService.getPressMovies().subscribe((res) => {
      this.movies = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }, () => this.loading = false
    );

  }

  goMovie(idMovie) {
    this.router.navigate(['/movie', idMovie]);
  }

  denyEntry() {
    this.authorised = false;
    Swal.fire({
      title: 'Sin Acceso',
      text: 'Lamentablemente no estás habilitado para ingresar a Sala de Prensa. Por favor escribinos a comunicacion@cinemateca.org.uy',
      icon: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: '<strong>CONTINUAR</strong>',
    }).then(async (result) => {
      this.router.navigateByUrl('/login');
    });
  }

}
